// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EmailTable_tableWrap-27vO6"};